export enum EndSessionReason {
    FINISHED = 'finished',
    CLOSED = 'closed',
    TIMEOUT = 'timeout',
    WINDOW_CLOSED = 'closed_site',
}
